export default __webpack_public_path__ + "static/media/44ebdee324a87687396cafed6af95ffe.jpg";